// extracted by mini-css-extract-plugin
module.exports = {"footer-espot-container--border":"footer-payment-shipping-espot_footer-espot-container--border__b7J8T"};